import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoginDto } from '../types';
import { validateEmail } from '../utils/helpers';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, error, loading, clearError } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState<LoginDto>({
    email: '',
    password: ''
  });
  const [formErrors, setFormErrors] = useState<any>({});

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev: any) => ({
        ...prev,
        [name]: ''
      }));
    }

    // Clear auth error
    if (error) {
      clearError();
    }
  };

  const validateForm = () => {
    const errors: any = {};

    if (!formData.email.trim()) {
      errors.email = 'E-posta adresi gereklidir';
    } else if (!validateEmail(formData.email)) {
      errors.email = 'Geçerli bir e-posta adresi girin';
    }

    if (!formData.password) {
      errors.password = 'Şifre gereklidir';
    } else if (formData.password.length < 6) {
      errors.password = 'Şifre en az 6 karakter olmalıdır';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      await login(formData);
      navigate('/dashboard');
    } catch (error) {
      // Error is handled by the context
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/dicle.png" alt="Dicle Üniversitesi" className="university-logo" />
          <h1 className="login-title">Dicle Üniversitesi</h1>
          <p className="login-description">Geribildirim Yönetim Sistemi</p>
        </div>

        <h2 className="login-subtitle">Personel Girişi</h2>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label className="form-label">E-posta Adresi</label>
            <input
              type="email"
              name="email"
              className={`form-input ${formErrors.email ? 'error' : ''}`}
              placeholder="E-posta adresinizi girin"
              value={formData.email}
              onChange={handleInputChange}
              required
              autoFocus
            />
            {formErrors.email && (
              <div className="form-error">{formErrors.email}</div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Şifre</label>
            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className={`form-input ${formErrors.password ? 'error' : ''}`}
                placeholder="Şifrenizi girin"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                aria-label="Şifreyi göster/gizle"
              >
                {showPassword ? '�️' : '👁️‍🗨️'}
              </button>
            </div>
            {formErrors.password && (
              <div className="form-error">{formErrors.password}</div>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary login-btn"
            disabled={loading}
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>

          <div className="login-footer">
            <p>
              Hasta geri bildirim formu için{' '}
              <button
                type="button"
                className="link-btn"
                onClick={() => navigate('/feedback-form')}
              >
                buraya tıklayın
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;